module.exports = __webpack_public_path__ + "img/1.fdcdb083.jpg";